import "$styles/index.css";
import "$styles/oauth.css";
import "$styles/trends.css";

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

// Import form validation
import "./registration-form-validation.js";
import "./unsubscribe-form-validation.js";
import "./oauth-google.js";
import "./hero-carousel.js";

// Import trend charts
import "./trend-charts.js";
